import { render } from "./TheHeader.vue?vue&type=template&id=16bb7a2e&scoped=true"
const script = {}

import "./TheHeader.vue?vue&type=style&index=0&id=16bb7a2e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16bb7a2e"]])

export default __exports__